// --------------------------------------------------------------
// Valor	    Tipo	    Significado
// --------------------------------------------------------------
// isAvailable	bool	    Hay micrófono conectado
// permission	"granted",  Estado actual del permiso
//              "denied",
//              "prompt"
// error	    string	    Mensaje si ocurrió error al chequear
// checking	    bool	    Si está en proceso de verificación
// --------------------------------------------------------------
// chrome://settings/content/microphone --> permitir explícitamente el uso para localhost:3001

import { useState, useEffect } from "react";
import { debugLog } from "../services/debugLog";

export default function useMicrophoneStatus() {
  const [isAvailable, setIsAvailable] = useState(false);   // si hay algún micrófono
  const [permission, setPermission] = useState("unknown"); // "granted", "denied", "prompt"
  const [error, setError] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    const checkMicrophone = async () => {
      setChecking(true);
      setError(null);

      try {
        if (isSafari) {
          // En Safari: pedimos acceso directamente
          await navigator.mediaDevices.getUserMedia({ audio: true });
          setIsAvailable(true);
          setPermission("granted");
        } else {
          // En otros navegadores: permisos + dispositivos
          if (!navigator.mediaDevices?.enumerateDevices) {
            const err = new Error("enumerateDevices is not available in this browser.");
            err.code = "ENUMERATE_NOT_AVAILABLE";
            throw err;
          }
          const devices = await navigator.mediaDevices.enumerateDevices();
          const hasMic = devices.some(device => device.kind === "audioinput");
          setIsAvailable(hasMic);

          if (navigator.permissions) {
            const status = await navigator.permissions.query({ name: "microphone" });
            setPermission(status.state);
            status.onchange = () => setPermission(status.state);
          } else {
            setPermission("prompt");
          }
        }
      } catch (err) {
        debugLog("🔴 Error al verificar micrófono:", err);
        setError(err.message || err.message || "Unknown error");
        setIsAvailable(false);
        setPermission("denied");
      }

      setChecking(false);
    };

    checkMicrophone();
  }, []);

  return { isAvailable, permission, error, checking };
}
